import type { A2HSCampaignProviderProps } from '../schema/A2HSCampaignProvider.types';
import { A2HSMetric, logMetric } from './a2hsMetrics';
import { isPWA } from 'mini-device-utils/lib/utils/isPWA';
import { isPWAInstalled } from './isPWAInstalled';
import { isUserBrowserSupportedForA2HSCampaign } from './isUserBrowserSupportedForA2HSCampaign';

export const isUserCandidateForA2HSCampaign = async ({
    suppressCampaign,
    supportedBrowserConfigs,
}: A2HSCampaignProviderProps): Promise<boolean> => {
    if (suppressCampaign) {
        return false;
    }

    if (isPWA()) {
        return false;
    }

    if (await isPWAInstalled()) {
        // Detect users having PWA installed but still using browser to access miniOWA.
        logMetric(A2HSMetric.PWA_INSTALLED);

        return false;
    }

    return isUserBrowserSupportedForA2HSCampaign(supportedBrowserConfigs);
};
